import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/InfoPages.css';

const Help = () => {
  return (
    <div className="info-page-container">
      <div className="info-page">
        <h1>Help</h1>

        <h2>Getting Started</h2>
        <ul>
          <li><strong>Create an Account</strong>: Sign up to access all Artifex features, including saving items, creating your Digital Card, and contributing content.</li>
          <li><strong>Digital Card</strong>: Your personalized aesthetic profile that filters content based on your preferences and evolves as you interact with the platform.</li>
          <li><strong>Exploring Artifex</strong>: Navigate between Discover, Guides, Editorials, Signals, and Shop using the main menu to explore different types of curated content.</li>
          <li><strong>Saving Items</strong>: Click the bookmark icon on any item to save it to your collection for future reference.</li>
          <li><strong>Sharing Content</strong>: Use the share icon to send items to friends or save links to your favorite discoveries.</li>
        </ul>

        <h2>Platform Features</h2>

        <h3>What is a Digital Card?</h3>
        <p>Your Digital Card is both your profile and preference filter. It represents your unique aesthetic sensibilities and helps personalize what content you see based on your interactions and saved items.</p>

        <h3>How do I use the Guides feature?</h3>
        <p>Guides provides curated, location-based recommendations for restaurants, shops, and cultural destinations. Click on map pins to see details, hours, and direct links to each location.</p>

        <h3>Can I contribute content to Artifex?</h3>
        <p>Yes! Contributors can submit products, articles, and recommendations for review. Visit the Contributor Dashboard to get started and track your submissions.</p>

        <h3>How is content selected for Artifex?</h3>
        <p>Content is sourced from museums, cultural institutions, open-access APIs, brand partnerships, and vetted contributor submissions. Everything is reviewed through our curation standards for quality, relevance, and aesthetic integrity.</p>

        <h3>How does the Shop work?</h3>
        <p>Our Shop features carefully selected design objects and products, many with affiliate links. When you purchase through these links, you support Artifex while discovering exceptional products.</p>

        <h3>How do I contact support?</h3>
        <p>For assistance, questions, or feedback, please email hello@a-r-t-i-f-e-x.com.</p>
        
        <div className="info-links">
          <Link to="/about">About</Link>
          <Link to="/terms">Terms</Link>
          <Link to="/privacy">Privacy</Link>
        </div>
      </div>
    </div>
  );
};

export default Help;